import { db } from "@/repositories/database";
import {
  type Project,
  type DRPartialProject,
  type GetProjectsFilters,
} from "@/types";
import type { RepositoryBaseInterface } from "@/repositories/repository.interface";
import { BaseRepository } from "@/repositories/base.repository";

const prepareForLocal = (item: Project): DRPartialProject => ({
  name: item.name,
  id: item.id,
  color: item.color,
  status: item.status,
  tags: item.tags,
  createdAt: item.createdAt,
  drawingsCount: item.drawingsCount,
  diagnosticsCount: item.diagnosticsCount,
  organizationId: item.organization_id,
});

class ProjectRepository
  extends BaseRepository<DRPartialProject, number>
  implements RepositoryBaseInterface<DRPartialProject>
{
  private currentOrganizationId: number | null = null;

  constructor() {
    super(db.projects, "project");
  }

  setCurrentOrganizationId(organizationId: number) {
    this.currentOrganizationId = organizationId;
  }

  createManyProjects(items: Project[]) {
    const preparedItems = items.map(prepareForLocal);
    this.upsertMany(preparedItems);
  }

  async getMany(
    filters: GetProjectsFilters,
    sortBy: "createdAt" | "name" | "status" = "createdAt"
  ) {
    if (!this.currentOrganizationId) return [];
    let organizationProjects = db.projects.orderBy(sortBy).and((project) => {
      return project.organizationId === this.currentOrganizationId;
    });

    if (filters.status)
      organizationProjects = organizationProjects.and((file) => {
        if (Array.isArray(filters.status)) {
          return filters.status.includes(file.status);
        }
        return file.status === filters.status;
      });

    return organizationProjects.toArray();
  }

  deleteById(id: number) {
    return db.projects.delete(id);
  }
}

export const projectRepository = new ProjectRepository();
